<div class="scaffold-sidebar-overlay">
  <div style="display:flex;">
    <div style="flex:1;">
      <div class="scaffold-editor-panel-heading">{{view?.panel_title||'settings'| translation}}</div>
    </div>
    <div>
      <button nbButton ghost size='giant' (click)="close()" aria-label="Close properties panel"><nb-icon pack="fas" icon="times"></nb-icon></button>
    </div>
  </div>
  <hr />
  <div class="sidebar-scroll-area">
    <app-view *ngIf="view" [items]="view.content" [info]="info" [data]="view_data"></app-view>
  </div>
</div>
